var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-toast_container",
      attrs: {
        opened: _vm.opened,
        theme: _vm.theme,
        type: _vm.type,
        duration: _vm.duration,
        icon: _vm.icon,
        "no-icon": _vm.noIcon,
        "show-close-icon": _vm.showCloseIcon,
      },
    },
    [
      _c("div", { staticClass: "toast__scrim", on: { click: _vm.hide } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "toast" },
        [
          _c("ns-icon", {
            staticClass: "toast__icon--close",
            attrs: { "icon-name": "icon-close" },
            on: { click: _vm.hide },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "message_action_container" }, [
            _c(
              "div",
              {
                staticClass: "title_message",
                class: [_vm.hideAction ? "hide_action" : ""],
              },
              [
                _c(
                  "div",
                  { staticClass: "exclusive_title" },
                  [
                    _c("ns-icon", {
                      attrs: {
                        "icon-name": "icon-exclusive-offer",
                        size: "icon-lg",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.exclusiveOfferTitle))]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.message))]),
              ]
            ),
            _vm._v(" "),
            !_vm.hideAction
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "class",
                        rawName: "v-class",
                        value: {
                          fluid:
                            _vm.$mq !== "desktop" && _vm.$mq !== "desktopHD",
                        },
                        expression:
                          "{fluid: ($mq !== 'desktop' && $mq !== 'desktopHD')}",
                      },
                    ],
                    staticClass: "secondary-outline message_action",
                    on: { click: _vm._messageAction },
                  },
                  [_vm._v(_vm._s(_vm.actionName))]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.hideSecondaryAction
              ? _c(
                  "button",
                  {
                    staticClass: "primary-ghost secondary_message_action",
                    attrs: {
                      fluid: _vm.$mq !== "desktop" && _vm.$mq !== "desktopHD",
                    },
                    on: { click: _vm._secondaryMessageAction },
                  },
                  [_vm._v(_vm._s(_vm.secondaryActionName))]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }